<template>
  <div :class="classList">
    <div class="st-information-box__icon">
      <slot name="icon">
        <component
          :is="icon"
          name="info"
          :icon-props="{ color: iconColor }"
          :aria-hidden="!ariaLabel"
          :aria-label="ariaLabel || null"
        />
      </slot>
    </div>
    <div class="st-information-box__description">
      <slot />
    </div>
  </div>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import { markRaw } from "vue";

export default {
  name: "st-information-box",
  components: {
    StIcon,
  },
  props: {
    informationType: {
      type: String,
      default: "info",
      validator(informationType) {
        return ["info", "danger", "plain", "highlight"].includes(
          informationType
        );
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
    },
  },
  data() {
    return {
      icon: markRaw(StIcon),
    };
  },
  computed: {
    classList() {
      const infoBox = "st-information-box";
      return [
        infoBox,
        this.small && `${infoBox}--is-small`,
        `${infoBox}--${this.informationType}`,
      ];
    },
    iconColor() {
      return this.informationType === "danger" ? "#DC001B" : "#514F4F";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-information-box {
  display: flex;
  align-items: top;
  border-radius: var(--border-radius);
  font-family: var(--font-primary);
  background: var(--container-color-tertiary);
  color: var(--text-color-primary);
  padding: var(--md);
  @include medium {
    padding: var(--lg);
  }
  &__icon {
    display: flex;
    margin-right: var(--sm);
  }
  &__description {
    font-size: rem-calc(16);
    line-height: 130%;
    align-self: center;
    flex: 1 1 auto;
  }
  &--is-small {
    display: inline-flex;
  }
  &--danger {
    background: var(--danger-color-secondary);
    border: rem-calc(2) solid var(--danger-color-primary);
  }
  &--plain {
    background: var(--palette-secondary-100);
    border: rem-calc(1) solid var(--disabled-color-secondary);
  }
  &--highlight {
    background: var(--background-color-quinary);
  }
}
</style>
